import React, { useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import ThemeInput from "../components/ThemeComponent/ThemeInput";
import { ThemeButton } from "../components/ThemeComponent/ThemeButtons";
import {
  AuthHeadingText,
  SimpleBasic,
  TextBasic,
} from "../components/ThemeComponent/ThemeText";
import { validation, validationText } from "../utils/constants.js";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { VscEye, VscEyeClosed } from "react-icons/vsc";
import { useSetNewPasswordMutation } from "../Redux/services/userAuthApi.js";
import { errorToast, success } from "../utils/helpers.js";

export default function SetNewPassword() {
  const [showPassword, setShowPassword] = useState(false);
  const [cnfrmShowPassword, setCnfrmShowPassword] = useState(false);
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handleShowCnfrmPassword = () => {
    setCnfrmShowPassword(!cnfrmShowPassword);
  };

  const [setNewPassword, { isLoading }] = useSetNewPasswordMutation();

  const onSubmit = async (data) => {
    try {
      const response = await setNewPassword(data).unwrap();

      console.log(response);

      if (response.code === 200) {
        success(response?.message || "OtP Verified Successfully");
        navigate("/");
      }
    } catch (error) {
      if (error?.response && error?.response?.data?.message) {
        errorToast(error?.response?.data?.message, "error");
      } else {
        errorToast("An error occurred during login", "error");
      }
    }
  };


  return (
    <div className="auth w-100">
      <AuthHeadingText text="Set New Password" className="w-100" />
      <SimpleBasic
        text="Please enter your new password"
        className="w-100 mb-3"
      />

      <Form onSubmit={handleSubmit(onSubmit)}>
        <div className="password-input mb-3">
          <ThemeInput
            name="new_password"
            control={control}
            errors={errors}
            rules={{
              required: {
                value: true,
                message: validationText.passwordRequired,
              },
              minLength: {
                value: validation.passwordMin,
                message: validationText.passwordMin,
              },
              maxLength: {
                value: validation.passwordMax,
                message: validationText.passwordMax,
              },
              pattern: {
                value:
                  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{12,20}$/,
                message:
                  "At least one letter, one number, one special character",
              },
            }}
            label=""
            placeholder="New Password"
            type={showPassword ? "text" : "password"}
            minLength={validation.passwordMin}
            maxLength={validation.passwordMax}
          />
          <span className="icon cursor" onClick={handleShowPassword}>
            {showPassword ? <VscEyeClosed className="text-black" /> : <VscEye className="text-black" />}
          </span>
        </div>

        <div className="password-input mb-2">
          <ThemeInput
            name="confirm_password"
            control={control}
            errors={errors}
            rules={{
              required: {
                value: true,
                message: validationText.passwordRequired,
              },
              minLength: {
                value: validation.passwordMin,
                message: validationText.passwordMin,
              },
              maxLength: {
                value: validation.passwordMax,
                message: validationText.passwordMax,
              },
              pattern: {
                value:
                  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{12,20}$/,
                message:
                  "At least one letter, one number, one special character",
              },
            }}
            label=""
            placeholder="Confirm New Password"
            type={cnfrmShowPassword ? "text" : "password"}
            minLength={validation.passwordMin}
            maxLength={validation.passwordMax}
          />
          <span className="icon cursor" onClick={handleShowCnfrmPassword}>
            {cnfrmShowPassword ? <VscEyeClosed className="text-black" /> : <VscEye className="text-black"/>}
          </span>
        </div>
        <div className="points mb-3">
          <ul>
            <li>At least 12 characters long but 14 or more is better.</li>
            <li>
              A combination of uppercase letters, lowercase letters, numbers,
              and symbols.
            </li>
          </ul>
        </div>
        <ThemeButton
          text="Continue"
          className="mt-4 mb-2 fw-bold w-100"
          type="submit"
          onClick={handleSubmit(onSubmit)}
        />
      </Form>
    </div>
  );
}
